/**
 * MT Product Stick - 产品粘性栏功能
 * 处理variant变化、价格更新、Buy Now链接更新、图片同步等功能
 */

(function() {
  'use strict';

  /**
   * 初始化产品粘性栏
   * @param {Object} config - 配置对象
   */
  function initProductStick(config) {
    const {
      mainFormSelector,
      submitButtonSelector,
      quantityInputSelector,
      sourceImageSelector,
      stickyButtonId,
      buyNowLinkId,
      productFormId,
      defaultVariantId,
      defaultImageUrl,
      cartUrl,
      currencyCode,
      productFormIdForPicker
    } = config;

    // 主表单（必须配置）
    if (!mainFormSelector) {
      console.error('主表单选择器未配置');
      return;
    }

    // 先按配置的选择器找表单（可能比较宽泛）
    let mainForm = document.querySelector(mainFormSelector);

    // 如果有传递 productFormId，用它来“纠正”到当前详情页表单，避免误拿到其他商品表单
    if (productFormId) {
      const specificForm = document.getElementById(productFormId);
      if (specificForm) {
        // 如果按选择器找到的表单和指定 id 不一致，则强制使用指定 id 的表单
        if (!mainForm || mainForm !== specificForm) {
          mainForm = specificForm;
        }
      }
    }

    if (!mainForm) {
      return;
    }

    // Sticky bar按钮和元素
    const stickyButton = document.querySelector(stickyButtonId);
    const buyNowLink = document.querySelector(buyNowLinkId);
    const priceElement = document.querySelector('.mt-product-current-price');
    const comparePriceElement = document.querySelector('.mt-product-compare-price');
    const productImage = document.querySelector('.mt-product-stick-img');
    // sourceImageSelector 是可选的，如果未配置则不使用图片监听方式
    const sourceImage = sourceImageSelector ? document.querySelector(sourceImageSelector) : null;

    // Loading helpers (prevent double-click + show spinner)
    function setLoading(el, isLoading, loadingText) {
      if (!el) return;
      if (isLoading) {
        if (!el.dataset) el.dataset = {};
        if (!el.dataset.mtOriginalText) {
          // Prefer textContent, but keep a fallback for non-text nodes
          el.dataset.mtOriginalText = (el.textContent || '').trim();
        }
        el.classList.add('is-loading');
        el.setAttribute('aria-busy', 'true');

        // Disable button if possible
        if (el.tagName === 'BUTTON') {
          el.disabled = true;
        } else {
          el.setAttribute('aria-disabled', 'true');
        }

        if (loadingText) {
          el.textContent = loadingText;
        }
      } else {
        el.classList.remove('is-loading');
        el.removeAttribute('aria-busy');
        el.removeAttribute('aria-disabled');
        if (el.tagName === 'BUTTON') {
          el.disabled = false;
        }
        if (el.dataset && el.dataset.mtOriginalText) {
          el.textContent = el.dataset.mtOriginalText;
        }
      }
    }

    // Clear loading after cart updates (for sticky ATC)
    function bindCartLoadingEndOnce() {
      if (window.__mtAtcLoadingBound) return;
      window.__mtAtcLoadingBound = true;

      const clear = function() {
        setLoading(stickyButton, false);
      };

      window.addEventListener('cart:updated', clear);
      document.documentElement.addEventListener('cart:refresh', clear);
    }

   

    // Buy Now 点击：直接根据当前变体和数量跳转到 /cart/{variant}:{qty}?checkout
    if (buyNowLink) {
      // 关键：先克隆并替换节点，移除其他脚本（如 mt-product.js）在此按钮上绑定的监听
      const clonedBuyNowLink = buyNowLink.cloneNode(true);
      buyNowLink.parentNode.replaceChild(clonedBuyNowLink, buyNowLink);

      clonedBuyNowLink.addEventListener('click', async function (e) {
        e.preventDefault();
        e.stopPropagation();
        try {
          const quantity = getCurrentQuantity();
          const mainVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
          const mainQuantityInput = getQuantityInput();

          const variantId = mainVariantInput && mainVariantInput.value
            ? mainVariantInput.value
            : defaultVariantId;

          if (!variantId) {
            setLoading(clonedBuyNowLink, false);
            return;
          }

          // 同步数量到主表单（确保主表单后续提交状态一致）
          if (mainQuantityInput) {
            mainQuantityInput.value = quantity;
            mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
            mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
          }

          // 检查是否有选中的捆绑商品
          const selectedBundleCards = document.querySelectorAll('.mt-bundle-product-card.selected');
          
          const hasBundleProducts = selectedBundleCards.length > 0;
          
          if (hasBundleProducts) {
            // 如果有捆绑商品，使用 Storefront API 创建购物车
            const token = window.__SF_TOKEN__ || (window.initBundleProducts && window.storefrontToken);
            
            if (!token) {
              // 回退到直接跳转方式
              const checkoutUrl = cartUrl + '/' + variantId + ':' + quantity + '?checkout';
              clonedBuyNowLink.href = checkoutUrl;
              window.location.href = checkoutUrl;
              return;
            }

            // 构建购物车项目（主商品 + 捆绑商品）
            const items = [];
            
            // 添加主商品
            items.push({
              id: parseInt(variantId, 10),
              quantity: quantity
            });
            
            
            // 添加捆绑商品
            let bundleCount = 0;
            selectedBundleCards.forEach(function(card) {
              const bundleVariantId = card.getAttribute('data-variant-id');
              
              if (!bundleVariantId || bundleVariantId === 'undefined' || bundleVariantId === 'null' || bundleVariantId === '') {
                return;
              }
              
              const bundleVariantIdNum = parseInt(bundleVariantId, 10);
              if (isNaN(bundleVariantIdNum) || bundleVariantIdNum <= 0) {
                return;
              }
              
              const bundleQtyInput = card.querySelector('.mt-bundle-qty');
              const bundleQty = bundleQtyInput ? Math.max(1, parseInt(bundleQtyInput.value || '1', 10)) : 1;
              
              bundleCount++;
              items.push({
                id: bundleVariantIdNum,
                quantity: bundleQty
              });
              
            });
            
            // 合并相同 variantId 的商品
            const merged = {};
            items.forEach(function(item) {
              if (!item || !item.id) return;
              if (!merged[item.id]) {
                merged[item.id] = { id: item.id, quantity: 0 };
              }
              merged[item.id].quantity += Number(item.quantity || 1);
            });
            
            const finalItems = Object.keys(merged).map(function(key) {
              return merged[key];
            });
            
            
            // 转换为 Storefront API 格式
            const lines = finalItems.map(function(it) {
              return {
                quantity: Number(it.quantity || 1),
                merchandiseId: 'gid://shopify/ProductVariant/' + Number(it.id)
              };
            });
            
            
            // 调用 Storefront API 创建购物车
            try {
              const query = `
                mutation CartCreate($lines: [CartLineInput!]!) {
                  cartCreate(input: { 
                    lines: $lines
                  }) {
                    cart { checkoutUrl }
                    userErrors { message }
                  }
                }
              `;
              
              const res = await fetch('/api/2024-07/graphql.json', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept': 'application/json',
                  'X-Shopify-Storefront-Access-Token': token
                },
                body: JSON.stringify({ query: query, variables: { lines: lines } })
              });
              
              const json = await res.json();
              
              const checkoutUrl = json && json.data && json.data.cartCreate && json.data.cartCreate.cart && json.data.cartCreate.cart.checkoutUrl;
              const err = (json && json.errors && json.errors[0] && json.errors[0].message) ||
                          (json && json.data && json.data.cartCreate && json.data.cartCreate.userErrors && json.data.cartCreate.userErrors[0] && json.data.cartCreate.userErrors[0].message) ||
                          ('HTTP ' + res.status);
              
              if (!checkoutUrl) {
                throw new Error(err || 'cartCreate failed');
              }
              
              window.location.href = checkoutUrl;
              return;
            } catch (apiErr) {
              // 回退到直接跳转方式
              const checkoutUrl = cartUrl + '/' + variantId + ':' + quantity + '?checkout';
              clonedBuyNowLink.href = checkoutUrl;
              window.location.href = checkoutUrl;
              return;
            }
          } else {
            // 没有捆绑商品，使用原来的直接跳转方式
            const checkoutUrl = cartUrl + '/' + variantId + ':' + quantity + '?checkout';

            // 更新当前链接的 href，方便右键等操作
            clonedBuyNowLink.href = checkoutUrl;

            // 直接跳转到结账页
            window.location.href = checkoutUrl;
          }
        } catch (err) {
          console.error('[MT-ATC] Sticky Buy Now 处理报错', err);
        }
      });
    }

    // 获取主表单中的数量输入字段
    function getQuantityInput() {
      if (!quantityInputSelector) {
        return null;
      }

      const customInput = document.querySelector(quantityInputSelector);
      if (customInput) return customInput;

      if (mainForm) {
        const customInputInForm = mainForm.querySelector(quantityInputSelector);
        if (customInputInForm) return customInputInForm;
      }

      return null;
    }

    // 获取当前数量
    function getCurrentQuantity() {
      const quantityInput = getQuantityInput();
      if (quantityInput && quantityInput.value) {
        const quantity = parseInt(quantityInput.value, 10);
        return isNaN(quantity) || quantity < 1 ? 1 : quantity;
      }
      return 1;
    }

    // 触发主表单提交
    function triggerMainFormSubmit() {
      if (!mainForm) {
        console.error('Main form not found');
        return;
      }

      let mainVariantInput = mainForm.querySelector('input[name="id"]');
      const mainQuantityInput = getQuantityInput();

      if (!mainVariantInput || !mainVariantInput.value) {
        const variant = getCurrentVariantFromPicker();
        if (variant && variant.id) {
          if (!mainVariantInput) {
            mainVariantInput = document.createElement('input');
            mainVariantInput.type = 'hidden';
            mainVariantInput.name = 'id';
            mainForm.appendChild(mainVariantInput);
          }
          mainVariantInput.value = variant.id;
          updateVariantId(variant.id);
        } else {
          if (defaultVariantId) {
            if (!mainVariantInput) {
              mainVariantInput = document.createElement('input');
              mainVariantInput.type = 'hidden';
              mainVariantInput.name = 'id';
              mainForm.appendChild(mainVariantInput);
            }
            mainVariantInput.value = defaultVariantId;
            updateVariantId(defaultVariantId);
          } else {
            console.error('No variant selected and no default variant available');
            return;
          }
        }
      }

      if (mainVariantInput.disabled) {
        mainVariantInput.disabled = false;
      }

      if (mainQuantityInput) {
        const qty = getCurrentQuantity();
        mainQuantityInput.value = qty;
        mainQuantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      if (!submitButtonSelector) {
        console.error('加入购物车按钮选择器未配置');
        return;
      }

      let mainSubmitButton = document.querySelector(submitButtonSelector);
      if (!mainSubmitButton && mainForm) {
        mainSubmitButton = mainForm.querySelector(submitButtonSelector);
      }

      if (!mainSubmitButton) {
        console.error('找不到提交按钮:', submitButtonSelector);
        return;
      }

      if (mainSubmitButton.disabled) {
        console.error('Submit button is disabled');
        return;
      }

      mainSubmitButton.click();
    }

    // 更新Buy Now链接的函数
    function updateBuyNowLink(variantId) {
      if (buyNowLink && variantId) {
        const quantity = getCurrentQuantity();
        buyNowLink.href = cartUrl + '/' + variantId + ':' + quantity + '?checkout';
      }
    }

    // 格式化价格的辅助函数
    function formatMoney(cents) {
      if (!cents) return '';
      if (window.themeVariables && window.themeVariables.settings.moneyFormat) {
        const format = window.themeVariables.settings.moneyFormat;
        const amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount);
      }
      const amount = cents / 100;
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currencyCode || 'USD'
      }).format(amount);
    }

    // 更新价格的函数
    function updatePrice(variant) {
      if (variant) {
        if (priceElement && variant.price) {
          priceElement.textContent = formatMoney(variant.price);
        }
        if (comparePriceElement) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            comparePriceElement.textContent = formatMoney(variant.compare_at_price);
            comparePriceElement.style.display = '';
          } else {
            comparePriceElement.style.display = 'none';
          }
        }
        if (productImage) {
          let imageUrl = null;

          if (variant.featured_media && variant.featured_media.preview_image) {
            imageUrl = variant.featured_media.preview_image.src || variant.featured_media.preview_image.url;
          } else if (variant.featured_image) {
            if (typeof variant.featured_image === 'string') {
              imageUrl = variant.featured_image;
            } else if (variant.featured_image.src) {
              imageUrl = variant.featured_image.src;
            } else if (variant.featured_image.url) {
              imageUrl = variant.featured_image.url;
            }
          } else if (variant.image) {
            if (typeof variant.image === 'string') {
              imageUrl = variant.image;
            } else if (variant.image.src) {
              imageUrl = variant.image.src;
            } else if (variant.image.url) {
              imageUrl = variant.image.url;
            }
          }

          if (imageUrl) {
            if (imageUrl.startsWith('//')) {
              imageUrl = window.location.protocol + imageUrl;
            }
            // 更新图片，并确保 URL 格式正确
            if (imageUrl && !imageUrl.startsWith('http') && !imageUrl.startsWith('/')) {
              // 如果是相对路径，可能需要添加域名
              imageUrl = imageUrl.startsWith('//') ? window.location.protocol + imageUrl : imageUrl;
            }
            productImage.src = imageUrl;
            productImage.onerror = function() {
              if (defaultImageUrl && this.src !== defaultImageUrl) {
                this.src = defaultImageUrl;
              }
            };
          } else if (productImage && defaultImageUrl) {
            // 如果 variant 没有图片，使用默认图片
            productImage.src = defaultImageUrl;
          }
        }
      }
    }

    // 从variant-picker中获取当前选中的variant数据
    function getCurrentVariantFromPicker() {
      const variantPicker = document.querySelector('variant-picker[form-id="' + productFormIdForPicker + '"]');
      if (variantPicker) {
        const variantScript = variantPicker.querySelector('script[data-variant]');
        if (variantScript) {
          try {
            const variant = JSON.parse(variantScript.textContent);
            return variant;
          } catch (e) {
            console.error('Error parsing variant data:', e);
          }
        }
      }
      return null;
    }

    function getVariantFromPicker(variantId) {
      const variant = getCurrentVariantFromPicker();
      if (variant && variant.id == variantId) {
        return variant;
      }
      return null;
    }

    function getMainFormVariantInput() {
      if (mainForm) {
        const mainVariantInput = mainForm.querySelector('input[name="id"]');
        return mainVariantInput;
      }
      return null;
    }

    function updateVariantId(variantId) {
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput) {
        mainVariantInput.value = variantId;
        if (mainVariantInput.disabled) {
          mainVariantInput.disabled = false;
        }
        mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // 监听variant变化事件
    if (mainForm) {
      mainForm.addEventListener('variant:change', function(event) {
        const variant = event.detail?.variant;
        if (variant && variant.id) {
          updateVariantId(variant.id);
          setTimeout(function() {
            updateBuyNowLink(variant.id);
          }, 50);
          updatePrice(variant);
        }
      });

      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput) {
        mainVariantInput.addEventListener('change', function() {
          const variantId = this.value;
          if (variantId) {
            setTimeout(function() {
              updateBuyNowLink(variantId);
            }, 50);
            const variant = getCurrentVariantFromPicker();
            if (variant && variant.id == variantId) {
              updatePrice(variant);
            } else {
              const variant = getVariantFromPicker(variantId);
              if (variant) {
                updatePrice(variant);
              }
            }
          }
        });
      }

      const quantityInput = getQuantityInput();
      if (quantityInput) {
        const updateBuyNowFromQuantity = function() {
          const currentVariantInput = getMainFormVariantInput();
          if (currentVariantInput && currentVariantInput.value) {
            updateBuyNowLink(currentVariantInput.value);
          }
        };

        quantityInput.addEventListener('change', updateBuyNowFromQuantity);
        quantityInput.addEventListener('input', updateBuyNowFromQuantity);
      }

      if (quantityInputSelector) {
        const quantityInputElement = document.querySelector(quantityInputSelector);
        if (quantityInputElement && quantityInputElement.is) {
          quantityInputElement.addEventListener('change', function() {
            const currentVariantInput = getMainFormVariantInput();
            if (currentVariantInput && currentVariantInput.value) {
              updateBuyNowLink(currentVariantInput.value);
            }
          });
          quantityInputElement.addEventListener('input', function() {
            const currentVariantInput = getMainFormVariantInput();
            if (currentVariantInput && currentVariantInput.value) {
              updateBuyNowLink(currentVariantInput.value);
            }
          });
        }
      }
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        bindCartLoadingEndOnce();
        setLoading(stickyButton, true, 'Adding...');
        try {
          const currentVariantInput = getMainFormVariantInput();
          const currentVariantId = currentVariantInput ? currentVariantInput.value : null;
          const quantity = getCurrentQuantity();
        } catch (err) {
          console.error('[MT-ATC DEBUG] Sticky ATC 调试报错', err);
        }
        triggerMainFormSubmit();

        // Fallback: if theme doesn't emit cart events for some reason, restore after a while.
        // 将原来的 8000ms 缩短为 3000ms，减少“长时间转圈”的体感。
        setTimeout(function() {
          setLoading(stickyButton, false);
        }, 3000);
      });
    }

    // 图片同步相关
    let imageObservers = [];
    let isListenerSetup = false;
    let lastSyncedSrc = '';

    function syncImageFromSource() {
      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (currentSourceImage && productImage) {
        let currentSrc = currentSourceImage.src ||
                        currentSourceImage.getAttribute('src') ||
                        currentSourceImage.getAttribute('data-src') ||
                        (currentSourceImage.querySelector && currentSourceImage.querySelector('img')?.src);

        if (!currentSrc && currentSourceImage.srcset) {
          currentSrc = currentSourceImage.srcset.split(',')[0].trim().split(' ')[0];
        }

        if (currentSrc && currentSrc !== lastSyncedSrc && productImage.src !== currentSrc) {
          productImage.src = currentSrc;
          lastSyncedSrc = currentSrc;
        }
      }
    }

    function setupSourceImageListener() {
      // 如果未配置 image_selector，则跳过图片监听，直接使用 variant 图片
      if (!sourceImageSelector || !sourceImageSelector.trim()) {
        return;
      }

      if (isListenerSetup) {
        return;
      }

      const currentSourceImage = document.querySelector(sourceImageSelector);
      if (!currentSourceImage || !productImage) {
        if (setupSourceImageListener.retryCount === undefined) {
          setupSourceImageListener.retryCount = 0;
        }
        if (setupSourceImageListener.retryCount < 10) {
          setupSourceImageListener.retryCount++;
          setTimeout(setupSourceImageListener, 300);
        }
        return;
      }

      isListenerSetup = true;
      syncImageFromSource();

      const imageObserver = new MutationObserver(function(mutations) {
        let shouldSync = false;
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes') {
            const attrName = mutation.attributeName;
            if (attrName === 'src' || attrName === 'srcset' || attrName === 'data-src') {
              shouldSync = true;
            }
          } else if (mutation.type === 'childList') {
            shouldSync = true;
          }
        });
        if (shouldSync) {
          setTimeout(syncImageFromSource, 50);
        }
      });

      imageObserver.observe(currentSourceImage, {
        attributes: true,
        attributeFilter: ['src', 'srcset', 'data-src'],
        childList: true,
        subtree: true
      });

      imageObservers.push(imageObserver);

      if (currentSourceImage.tagName === 'IMG') {
        currentSourceImage.addEventListener('load', syncImageFromSource);
        currentSourceImage.addEventListener('error', syncImageFromSource);
      }

      const innerImages = currentSourceImage.querySelectorAll('img');
      innerImages.forEach(function(innerImg) {
        innerImg.addEventListener('load', syncImageFromSource);
        innerImg.addEventListener('error', syncImageFromSource);

        const innerObserver = new MutationObserver(function() {
          setTimeout(syncImageFromSource, 50);
        });
        innerObserver.observe(innerImg, {
          attributes: true,
          attributeFilter: ['src', 'srcset', 'data-src']
        });
        imageObservers.push(innerObserver);
      });

      const allSourceImages = document.querySelectorAll(sourceImageSelector);
      allSourceImages.forEach(function(img) {
        if (img !== currentSourceImage) {
          const imgObserver = new MutationObserver(function(mutations) {
            let shouldSync = false;
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' &&
                  (mutation.attributeName === 'src' || mutation.attributeName === 'srcset' || mutation.attributeName === 'data-src')) {
                shouldSync = true;
              }
            });
            if (shouldSync) {
              setTimeout(syncImageFromSource, 50);
            }
          });
          imgObserver.observe(img, {
            attributes: true,
            attributeFilter: ['src', 'srcset', 'data-src'],
            childList: true,
            subtree: true
          });
          imageObservers.push(imgObserver);

          if (img.tagName === 'IMG') {
            img.addEventListener('load', syncImageFromSource);
            img.addEventListener('error', syncImageFromSource);
          }
        }
      });

      const checkInterval = setInterval(function() {
        syncImageFromSource();
      }, 500);

      if (!window.mtImageSyncIntervals) {
        window.mtImageSyncIntervals = [];
      }
      window.mtImageSyncIntervals.push(checkInterval);
    }

    setupSourceImageListener();
    setTimeout(setupSourceImageListener, 100);
    setTimeout(setupSourceImageListener, 500);
    setTimeout(setupSourceImageListener, 1000);
    setTimeout(setupSourceImageListener, 2000);

    // 初始化Buy Now链接和价格
    function initializeStickyBar() {
      const mainVariantInput = getMainFormVariantInput();
      if (mainVariantInput && mainVariantInput.value) {
        updateBuyNowLink(mainVariantInput.value);
        const variant = getCurrentVariantFromPicker();
        if (variant && variant.id == mainVariantInput.value) {
          updatePrice(variant);
        }
      } else {
        let variant = getCurrentVariantFromPicker();
        if (variant && variant.id) {
          updateVariantId(variant.id);
          updateBuyNowLink(variant.id);
          updatePrice(variant);
        } else {
          if (defaultVariantId) {
            let variantInput = getMainFormVariantInput();
            if (!variantInput && mainForm) {
              variantInput = document.createElement('input');
              variantInput.type = 'hidden';
              variantInput.name = 'id';
              mainForm.appendChild(variantInput);
            }
            if (variantInput) {
              variantInput.value = defaultVariantId;
              updateVariantId(defaultVariantId);
              updateBuyNowLink(defaultVariantId);
              if (window.productData && window.productData.variants) {
                variant = window.productData.variants.find(v => v.id === defaultVariantId);
                if (variant) {
                  updatePrice(variant);
                }
              }
            }
          }
        }
      }
    }

    initializeStickyBar();
    setTimeout(initializeStickyBar, 100);
    setTimeout(initializeStickyBar, 500);

    // 展开/收起功能
    const toggleButton = document.querySelector('.mt-product-stick-toggle');
    const productStick = document.querySelector('.mt-product-stick');
    
    if (toggleButton && productStick) {
      toggleButton.addEventListener('click', function() {
        productStick.classList.toggle('expanded');
      });
    }
  }

  /**
   * 初始化产品粘性栏的显示/隐藏逻辑
   * @param {Object} config - 配置对象
   */
  function initProductStickVisibility(config) {
  const { disappearClass } = config;
  const customProductPrice = document.querySelector(disappearClass ? '.' + disappearClass : '');

  // 查找 footer 元素（优先使用主题真实 footer，再退回通用选择器）
  let footerEl = null;
  // 1. 先尝试你主题里真实的 footer：<footer class="mt-footer" ...>
  footerEl = document.querySelector('footer.mt-footer') || document.querySelector('.mt-footer');
  // 2. 如果还没找到，再退回到通用 footer 选择器
  if (!footerEl) {
    footerEl = document.querySelector('footer');
  }
  if (!footerEl) {
    footerEl = document.querySelector('.footer, #footer, [class*="footer"], [id*="footer"]');
  }

  const productStick = document.querySelector('.mt-product-stick');

    if (!productStick) return;

    let priceElementVisible = false;
    let footerVisible = false;

    function updateProductStickVisibility() {
      if (priceElementVisible || footerVisible) {
        productStick.classList.add('is-hidden');
      } else {
        productStick.classList.remove('is-hidden');
      }
    }

    function checkPriceVisibility() {
      if (!customProductPrice) return;

      const rect = customProductPrice.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      priceElementVisible = rect.bottom > 0 && rect.top < windowHeight;
      updateProductStickVisibility();
    }

    if (customProductPrice) {
      const priceIO = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          priceElementVisible = entry && entry.isIntersecting;
          updateProductStickVisibility();
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '0px'
        }
      );
      priceIO.observe(customProductPrice);

      let scrollTimeout;
      window.addEventListener('scroll', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(checkPriceVisibility, 50);
      });

      window.addEventListener('resize', function() {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(checkPriceVisibility, 50);
      });

      checkPriceVisibility();
    }

  if (footerEl) {
    const rect = footerEl.getBoundingClientRect();

    // 如果 footer 节点本身是 0 尺寸（占位元素），直接忽略，避免误判
    if (rect.width === 0 && rect.height === 0) {
      console.log('[MTProductStick] footer 元素尺寸为 0，被视为占位元素，忽略 IntersectionObserver');
    } else {
      const footerIO = new IntersectionObserver(
        (entries) => {
          const entry = entries[0];
          footerVisible = !!(entry && entry.isIntersecting);
          updateProductStickVisibility();
        },
        {
          root: null,
          threshold: 0.01,
        }
      );
      footerIO.observe(footerEl);

      const footerTop = rect.top;
      const footerBottom = rect.bottom;
      const windowHeight = window.innerHeight;

      // 初始判断：只要 footer 任意部分在视口内，就视为可见
      footerVisible = footerTop < windowHeight && footerBottom > 0;
      updateProductStickVisibility();
    }
  }
  }

  // 导出到全局
  window.MTProductStick = {
    init: initProductStick,
    initVisibility: initProductStickVisibility
  };
})();

document.addEventListener('DOMContentLoaded', function () {
  const nameCollapsed = document.querySelector('.mt-product-name-collapsed');

  if (!nameCollapsed) return;

  function getSelectedText() {
    const spans = document.querySelectorAll('.mt-variant-selected');
    const texts = Array.from(spans)
      .map(el => el.textContent.trim())
      .filter(Boolean);
    return texts.join(' / ');
  }

  // 初始同步一次
  const initText = getSelectedText();
  if (initText) {
    nameCollapsed.textContent = initText;
  }

  // 利用现有的 variant:change 事件（mt-product.js 已经在触发）
  document.addEventListener('variant:change', function () {
    const text = getSelectedText();
    if (text) {
      nameCollapsed.textContent = text;
    }
  });
});
